import React from 'react';

import { Container } from '@components/Container';
import { Layout } from '@components/Layout';
import { makeMuiStyles, useCommonStyles } from '@styles/index';
import { createStrings } from '@utils/local';

const strings = createStrings({
  ja: {
    title: '【重要】中国旧正月期間中のスケジュールのご案内',
    date: '2023.01.12',
    content: () => (
      <>
        <p>
          【ご案内】
          <br />
          平素よりD2Dサービスをご利用いただき、誠にありがとうございます。
          <br />
          旧正月期間のスケジュールは下記のとおり予定しております。
          <br />
          <br />
          尚、本件に関しご不明な点がございましたら、弊社営業担当までお問い合せ下さい。
          <br />
        </p>

        <p style={{ textAlign: 'center' }}>記</p>

        <p style={{ textAlign: 'end' }}>以上</p>
      </>
    ),
  },
});

const useStyles = makeMuiStyles((theme, common) => ({
  title: {
    ...common.normalText,
    textAlign: 'center',
    fontWeight: 700,
    fontSize: 30,
    lineHeight: '42px',
    marginBottom: '6rem',
  },
  content: {
    ...common.normalText,
    ...common.textGray700,
  },
  scheduleTableTitle: {
    ...common.textAlignCenter,
    ...common.textGray700,
    ...common.bigText,
    ...common.fontWeight600,
    padding: '22px 0px',
  },
  scheduleTableContainer: {
    ...common.flexColumn,
    padding: 28,
    border: `1px solid ${theme.palette.grey[700]}`,
    rowGap: '1rem',
  },
  scheduleTable: {
    ...common.middleText,
    display: 'grid',
    gridTemplateColumns: 'repeat(8, auto)',
    '& div': {
      ...common.textAlignCenter,
      padding: '10px 8px',
      borderBottom: `1px solid ${theme.palette.grey[400]}`,
    },
  },
}));

interface ScheduleTableProps {
  city: string;
  title: string;
  table: string[][];
}

const ScheduleTable = (props: ScheduleTableProps) => {
  const { city, title, table } = props;

  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  return (
    <div>
      <div className={classes.scheduleTableTitle}>{title}</div>

      <div className={classes.scheduleTable}>
        <div></div>
        <div>{city}倉庫荷受けCUT日</div>
        <div>上海ETD</div>
        <div>東京ETA</div>
        <div>大阪ETA</div>
        <div>名古屋ETA</div>
        <div>博多ETA</div>
        <div>日本の最短納品日</div>

        {table.map((row) =>
          row.map((cell, i) =>
            cell === 'NO SERVICE' ? (
              <div key={i} style={{ gridColumn: 'span 7' }}>
                {cell}
              </div>
            ) : (
              <div key={i}>{cell}</div>
            ),
          ),
        )}
      </div>
    </div>
  );
};

export const ChineseNewYear2023 = () => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  return (
    <Layout title={strings.title}>
      <Container>
        <div className={classes.title}>
          {strings.title}
          <br />
          <span className={classes.normalText}>{strings.date}</span>
        </div>
        <div className={classes.content}>{strings.content()}</div>

        <div className={classes.scheduleTableContainer}>
          <ScheduleTable
            city="上海"
            title="D2D航路 2023年旧正月期間中 2023/01/17~2023/01/21"
            table={[
              ['上海', '2023/01/17', '2023/01/20', '2023/01/23', '', '', '', '2023/01/26'],
              ['上海', '2023/01/17', '2023/01/20', '', '2023/01/23', '', '', '2023/01/26'],
              ['上海', '2023/01/17', '2023/01/20', '', '', '2023/01/23', '', '2023/01/26'],
              ['上海', '2023/01/18', '2023/01/21', '', '', '', '2023/01/23', '2023/01/27'],
            ]}
          />

          <ScheduleTable
            city="上海"
            title="D2D航路 2023年旧正月期間中 2023/01/21~2023/01/31"
            table={[['上海', 'NO SERVICE']]}
          />

          <ScheduleTable
            city="上海"
            title="D2D航路 2023年旧正月明け後 2023/01/31~2023/02/10"
            table={[
              ['上海', '2023/01/31', '2023/02/03', '2023/02/06', '', '', '', '2023/02/09'],
              ['上海', '2023/01/31', '2023/02/03', '', '2023/02/06', '', '', '2023/02/09'],
              ['上海', '2023/01/31', '2023/02/03', '', '', '2023/02/06', '', '2023/02/09'],
              ['上海', '2023/01/31', '2023/02/04', '', '', '', '2023/02/06', '2023/02/10'],
            ]}
          />
        </div>

        <div style={{ height: 64 }} />

        <div className={classes.scheduleTableContainer}>
          <ScheduleTable
            city="広東"
            title="D2DSHENZHEN+航路 2023年旧正月期間中 2023/01/17~2023/01/21"
            table={[
              ['広東', '2023/01/13', '2023/01/20', '2023/01/23', '', '', '', '2023/01/26'],
              ['広東', '2023/01/13', '2023/01/20', '', '2023/01/23', '', '', '2023/01/26'],
              ['広東', '2023/01/13', '2023/01/20', '', '', '2023/01/23', '', '2023/01/26'],
              ['広東', '2023/01/13', '2023/01/21', '', '', '', '2023/01/24', '2023/01/27'],
            ]}
          />

          <ScheduleTable
            city="広東"
            title="D2D航路 2023年旧正月期間中 2023/01/21~2023/01/31"
            table={[['広東', 'NO SERVICE']]}
          />

          <ScheduleTable
            city="広東"
            title="D2D SHENZHEN+航路 2023年旧正月明け後 2023/01/31~2023/02/10"
            table={[
              ['広東', '2023/01/28', '2023/02/03', '2023/02/06', '', '', '', '2023/02/09'],
              ['広東', '2023/01/28', '2023/02/03', '', '2023/02/06', '', '', '2023/02/09'],
              ['広東', '2023/01/28', '2023/02/03', '', '', '2023/02/06', '', '2023/02/09'],
              ['広東', '2023/01/28', '2023/02/04', '', '', '', '2023/02/06', '2023/02/10'],
            ]}
          />
        </div>
      </Container>
    </Layout>
  );
};
